import { Component, OnInit } from '@angular/core';
import { AppComponent } from 'src/app/app.component';
import {
  MxAppColorSchemeService,
  MxAppSidebarService,
  MxMenuService,
} from '../../services';
import { MainComponent } from './main.component';

@Component({ standalone: false,
  selector: 'mx-menu',
  templateUrl: './menu.component.html',
})
export class MenuComponent implements OnInit {
  public model: any[];

  constructor(
    public main: MainComponent,
    public appColorSchemeService: MxAppColorSchemeService,
    public appSidebarService: MxAppSidebarService,
    private menuService: MxMenuService
  ) {}

  ngOnInit() {
    this.model = this.menuService.menu;
  }
}
